export function forEachObjectKey<T, U>(object: Record<string, T>, func: (value: T) => U): Record<string, U> {
  const newObject: Record<string, U> = {};
  if (typeof object !== 'object' || object === null) {
    return newObject;
  }
  Object.keys(object).forEach((key) => {
    newObject[key] = func(object[key]);
  });
  return newObject;
}
